import styled from 'styled-components';

export const LineVerticalStyled = styled.div`
  width: 1px;
  height: 18px;
  background: #d9d9d8;
`;
